import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = ["onClick"]

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import { config } from "@/common/settings/config";

import { breadcrumbSimple, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();

const menuList = computed(() =>
  config.menu.register.map((item) => ({
    ...item,
    label: t(item.label),
  }))
);

const breadcrumbList = computed(() => [
  {
    key: "register",
    label: t("common.labels.registrations"),
    url: "/register",
  },
]);

function changeMenu(menu: any) {
  if (menu.url && !menu.external) router.push(menu.url);
  if (menu.url && menu.external) window.open(menu.url, "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "register"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (menu) => {
        return (_openBlock(), _createElementBlock("button", {
          key: menu.key,
          class: "item",
          onClick: ($event: any) => (changeMenu(menu))
        }, [
          _createVNode(_unref(svgIcon), {
            icon: menu.icon,
            size: "4rem"
          }, null, 8, ["icon"]),
          _createElementVNode("span", null, _toDisplayString(menu.label), 1)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})